import { Box } from '@mui/material'
import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import React from 'react'

import { useRemoveFromGroup } from '@/app/module/groups/hooks/use-remove-from-group'

import { useGetGroupOptions } from '../hooks/use-get-group-options'

type Props = {
  contactIds: string[]
  includedGroupIds: string[]
  recipients: { label: string; value: string }[]
  selectedGroup?: string
  totalRecipients: number
  closeHandler: () => void
  onRemoveFromGroupSuccess?: () => void
}

const RemoveFromGroup: React.FC<Props> = ({
  contactIds,
  includedGroupIds,
  recipients,
  selectedGroup,
  totalRecipients,
  closeHandler,
  onRemoveFromGroupSuccess,
}) => {
  const [removeFromGroup, { isLoading: isRemoving }] = useRemoveFromGroup()

  const { data: groups } = useGetGroupOptions({
    page: 1,
  })

  const groupName = React.useMemo(() => {
    const found = groups.find((g) => g.value === selectedGroup)
    return found?.label ?? ''
  }, [groups, selectedGroup])

  const handleSubmit = async () => {
    if (!selectedGroup) {
      return
    }
    let ok = false
    try {
      ok = await removeFromGroup({
        groupId: selectedGroup,
        contactIds,
        includedGroupIds,
      })
    } finally {
      closeHandler()
      if (ok) {
        onRemoveFromGroupSuccess?.()
      }
    }
  }

  const contactsString = totalRecipients === 1 ? 'contact' : 'contacts'

  return (
    <form
      id="remove-from-form"
      onSubmit={(e) => {
        e.preventDefault()
        if (!recipients.length) {
          return
        }
        handleSubmit()
      }}
    >
      <CardContent>
        <Typography>{`Are you sure you want to remove ${totalRecipients} ${contactsString} from ${groupName}?`}</Typography>
      </CardContent>
      <CardActions>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end">
          <Button
            id="remove-from-group-action"
            autoFocus
            color="secondary"
            loading={isRemoving}
            type="submit"
            variant="contained"
          >
            Remove
          </Button>
        </Box>
      </CardActions>
    </form>
  )
}

export default RemoveFromGroup

export type { Props as RemoveFromGroupProps }
